export const FILE_TYPE = {
  IMAGE: "IM",
  VIDEO: "VI",
  AUDIO: "AU",
};
